import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
//Redux
import * as sessionActions from "../../redux/user/actions";
//Components
import UserListing from "../../components/UserListing";
import UserCreation from "../../components/UserCreation";
import UserDetail from "../../components/UserDetail";
import VehicleOnBoarding from "../../components/VehicleOnboard";
import RidersRegister from "../../components/RiderRegister";
import OnboardUserList from "../../components/OnBoardedUsersList";
import OnboardUserDetail from "../../components/OnBoardedUserDetail";
import PreRegisteredUser from "../../components/PreRegisteredUser";

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    // this.props.actions.fetchUserCountry();
    this.props.actions.clearPreviousReducer();
  }

  handleFetchDealer = (data) => {
    this.props.actions.fetchAllDealer(data);
  };

  handleFetchCountry = (data) => {
    this.props.actions.fetchCountry(data);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchCity(data);
  };

  handleFetchAllUser = (data) => {
    this.props.actions.fetchAllUser(data);
  };

  handleFetchSingleUser = (data) => {
    this.props.actions.fetchSingleUser(data);
  };

  handleCountryFetch = () => {
    this.props.actions.fetchUserCountry();
  };

  handleCountryMobileCodeFetch = () => {
    this.props.actions.fetchUserCountryMobileCode();
  };

  handleCountryJsonMobileCode = () => {
    this.props.actions.fetchUserCountryJSON();
  };
  handleCreateUser = (data) => {
    this.props.actions.createUser(data);
  };

  handleMotorCycleFetch = () => {
    this.props.actions.fetchMotorCylce();
  };

  handleVarientFetch = () => {
    this.props.actions.fetchVarient();
  };

  handleVechicleOnboarding = (data) => {
    this.props.actions.vechicleOnBoard(data);
  };

  handleFetchVechileData = (data) => {
    this.props.actions.vechicleDetail(data);
  };

  handleRidersRegister = (data) => {
    this.props.actions.ridersRegister(data);
  };

  handleFetchMotorCycle = (data) => {
    this.props.actions.fetchMotorCylce(data);
  };

  handleSearchFilter = () => {
    this.props.actions.searchFilterForUser();
  };

  handleClearPreviousReducers = () => {
    this.props.actions.clearPreviousReducer();
  };

  handleFetchOnBoardUserList = (data) => {
    this.props.actions.fetchOnBoardedUsers(data);
  };

  handleFetchOnBoardUserDetailList = (data) => {
    this.props.actions.fetchOnBoardedUsersDetail(data);
  };

  handleFetchPreRegisteredUser = (data) => {
    this.props.actions.fetchPreRegisteredUser(data);
  };

  handleExportToExcel = (data) => {
    this.props.actions.exportToExcel(data);
  };

  handlePendingVehicleOnboarding = (data) => {
    this.props.actions.pendingVehicleOnBoard(data);
  };

  handleFetchUserVehicles = (data) => {
    this.props.actions.fetchUserVehicles(data);
  };

  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "list":
        return (
          <UserListing
            handleFetchAllUser={this.handleFetchAllUser}
            handleSearchFilter={this.handleSearchFilter}
            handleClearPreviousReducers={this.handleClearPreviousReducers}
            allUserStatus={this.props.allUserStatus}
            allUser={this.props.allUser}
            searchFilter={this.props.searchFilter}
            userFilterStatus={this.props.userFilterStatus}
            elements={this.props.elements}
          />
        );
      case "creation":
        return (
          <UserCreation
            handleCountryMobileCodeFetch={this.handleCountryJsonMobileCode}
            handleCreateUser={this.handleCreateUser}
            country={this.props.country}
            countryMobileCode={this.props.countryJsonMobileCode}
            createUserStatus={this.props.createUserStatus}
            registerConsentForm={this.props.registerConsentForm}
            elements={this.props.elements}
          />
        );

      case "detail":
        return (
          <UserDetail
            query={this.props.location.search}
            singleUserStatus={this.props.singleUserStatus}
            singleUser={this.props.singleUser}
            userVehicles={this.props.userVehicles}
            handleFetchSingleUser={this.handleFetchSingleUser}
            handleFetchUserVehicles={this.handleFetchUserVehicles}
            handleClearPreviousReducers={this.handleClearPreviousReducers}
            elements={this.props.elements}
          />
        );

      case "vechile-onboarding":
        return (
          <VehicleOnBoarding
            query={this.props.location.search}
            motorCycleStatus={this.props.motorCycleStatus}
            motorCycle={this.props.motorCycle}
            motorCycleCountryStatus={this.props.motorCycleCountryStatus}
            motorCycleCountry={this.props.motorCycleCountry}
            handleFetchMotorCycle={this.handleFetchMotorCycle}
            handleVechicleOnboarding={this.handleVechicleOnboarding}
            handlePendingVehicleOnboarding={this.handlePendingVehicleOnboarding}
            vechicleOnboardingStatus={this.props.vechicleOnboardingStatus}
            elements={this.props.elements}
          />
        );

      case "riders-registration":
        return (
          <RidersRegister
            handleFetchVechileData={this.handleFetchVechileData}
            handleRidersRegister={this.handleRidersRegister}
            query={this.props.location.search}
            vechicleDetailStatus={this.props.vechicleDetailStatus}
            vechicleDetail={this.props.vechicleDetail}
            ridersRegisterStatus={this.props.ridersRegisterStatus}
            userProfile={this.props.userProfile}
            elements={this.props.elements}
          />
        );

      case "onboard-users-list":
        return (
          <OnboardUserList
            handleFetchOnBoardUserList={this.handleFetchOnBoardUserList}
            handleClearPreviousReducers={this.handleClearPreviousReducers}
            handleExportToExcel={this.handleExportToExcel}
            handleFetchDealer={this.handleFetchDealer}
            handleFetchCountry={this.handleFetchCountry}
            handleFetchState={this.handleFetchState}
            handleFetchCity={this.handleFetchCity}
            onBoardedUserStatus={this.props.onBoardedUserStatus}
            onBoardedUserCount={this.props.onBoardedUserCount}
            onBoardedUser={this.props.onBoardedUser}
            countryStatus={this.props.countryStatus}
            countries={this.props.country}
            stateStatus={this.props.stateStatus}
            states={this.props.states}
            cityStatus={this.props.cityStatus}
            cities={this.props.cities}
            dealerStatus={this.props.dealerStatus}
            dealerCount={this.props.dealerCount}
            dealers={this.props.dealers}
            elements={this.props.elements}
            usertype={this.props.usertype}
            accessibleCountries={this.props.accessibleCountries}
            userProfile={this.props.userProfile}
          />
        );

      case "onboard-users-Detail":
        return (
          <OnboardUserDetail
            handleFetchOnBoardUserDetailList={
              this.handleFetchOnBoardUserDetailList
            }
            onBoardedUserDetailStatus={this.props.onBoardedUserDetailStatus}
            onBoardedUserDetail={this.props.onBoardedUserDetail}
            query={this.props.location.search}
            elements={this.props.elements}
          />
        );

      case "pre-registration-users":
        return (
          <PreRegisteredUser
            handleFetchPreRegisteredUser={this.handleFetchPreRegisteredUser}
            handleClearPreviousReducers={this.handleClearPreviousReducers}
            handleExportToExcel={this.handleExportToExcel}
            preRegisteredUserStatus={this.props.preRegisteredUserStatus}
            preRegisteredUser={this.props.preRegisteredUser}
            query={this.props.location.search}
            preRegisteredUserCount={this.props.preRegisteredUserCount}
            exportToExcelStatus={this.props.exportToExcelStatus}
            elements={this.props.elements}
          />
        );

      default:
        return null;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
}

function mapStateToProps(state) {
  console.log({ state: state.User });
  return {
    countryStatus: state.User.countryStatus,
    country: state.Global.countries,
    countryMobileCodeStatus: state.User.countryMobileCodeStatus,
    countryMobileCode: state.User.countryMobileCode,
    countryJsonMobileCodeStatus: state.User.countryJsonMobileCodeStatus,
    countryJsonMobileCode: state.User.countryJsonMobileCode,
    allUserStatus: state.User.allUserStatus,
    allUser: state.User.allUser,
    vechicleOnboardingStatus: state.User.vechicleOnboardingStatus,
    vechicleDetailStatus: state.User.vechicleDetailStatus,
    vechicleDetail: state.User.vechicleDetail,
    singleUserStatus: state.User.singleUserStatus,
    singleUser: state.User.singleUser,
    createUserStatus: state.User.createUserStatus,
    ridersRegisterStatus: state.User.ridersRegisterStatus,
    userProfile: state.Auth.userProfile,
    motorCycleStatus: state.User.motorCycleStatus,
    motorCycle: state.User.motorCycle,
    motorCycleCountryStatus: state.User.motorCycleCountryStatus,
    motorCycleCountry: state.Global.countries,
    registerConsentForm: state.User.registerConsentForm,
    searchFilter: state.User.searchFilter,
    userFilterStatus: state.User.userFilterStatus,
    onBoardedUserStatus: state.User.onBoardedUserStatus,
    onBoardedUser: state.User.onBoardedUser,
    onBoardedUserCount: state.User.onBoardedUserCount,
    onBoardedUserDetailStatus: state.User.onBoardedUserDetailStatus,
    onBoardedUserDetail: state.User.onBoardedUserDetail,
    preRegisteredUserStatus: state.User.preRegisteredUserStatus,
    preRegisteredUser: state.User.preRegisteredUser,
    preRegisteredUserCount: state.User.preRegisteredUserCount,
    elements: state.Elements.elements,
    exportToExcelStatus: state.User.exportToExcelStatus,
    userVehicles: state.User.userVehicles,
    stateStatus: state.User.stateStatus,
    states: state.User.states,
    cityStatus: state.User.cityStatus,
    cities: state.User.cities,
    dealerStatus: state.User.dealerStatus,
    dealerCount: state.User.dealerCount,
    dealers: state.User.dealers,
    usertype: state.Auth.usertype,
    accessibleCountries: state.Auth.userProfile.accessibleCountries,
    userProfile: state.Auth.currentUserProfile,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(User));
